<div class="container-fluid p-0">

  <div class="alert alert-warning m-3" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view messages.
    <span *ngIf="canCreate">You can still create new messages using the button above.</span>
    <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
  </div>

  <ng-container *ngIf="canView">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <a class="navbar-brand" href="javascript:void(0)">Related Messages</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <span class="mr-auto">
          <ng-container *ngIf="canCreate">
            <button
              class="m-1 mr-2"
              type="button"
              color="primary"
              mat-raised-button
              (click)="onEditMessage()"
              matTooltip="Click this button to send a new message.">
              <mat-icon>add</mat-icon>
              New Message
            </button>
          </ng-container>
        </span>

        <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
          <mat-icon>filter_list</mat-icon> Filter
        </button>

        <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
          <input
            class="form-control ml-0 mr-2 my-1"
            type="search"
            [(ngModel)]="dataSource.search"
            name="search"
            placeholder="Search"
            aria-label="Search"
            id="search-input"
            matTooltip="Search the messages by subject, body, type, status and priority."/>

          <button
            mat-raised-button
            color="secondary"
            type="submit"
            class="mx-0 my-1"
            id="search-button"
            matTooltip="Click this button to run the current search.">
            <mat-icon>search</mat-icon> Search
          </button>
        </form>

      </div>
    </nav>

    <div class="mat-elevation-z8 scroll-box">
      <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

      <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

        <!-- Multiple item selector for lists. -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
            <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
              [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
              [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
              matTooltip="Toggle select all files in this list.">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
              (change)="$event ? dataSource.selection.toggle(row.id) : null"
              [checked]="dataSource.selection.isSelected(row.id)"
              matTooltip="Toggle select this file.">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- The ID of the message. -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the message.">
            ID #
          </th>
          <td mat-cell *matCellDef="let message">
            {{ message.id }}
          </td>
        </ng-container>

        <!-- Subject -->
        <ng-container matColumnDef="subject">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the subject of the message.">
            Subject
          </th>
          <td mat-cell *matCellDef="let message" class="text-wrap">
            {{ message.subject }}
          </td>
        </ng-container>

        <!-- Type -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the message type.">
            Type
          </th>
          <td mat-cell *matCellDef="let message">
            {{ message.type | titlecase }}
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the status of the message.">
            Status
          </th>
          <td mat-cell *matCellDef="let message">
            {{ message.status | titlecase }}
          </td>
        </ng-container>

        <!-- Priority -->
        <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the priority of the message.">
            Priority
          </th>
          <td mat-cell *matCellDef="let message">
            {{ message.priority | titlecase }}
          </td>
        </ng-container>

        <!-- Date the message was created. -->
        <ng-container matColumnDef="date_created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the message was created.">
            Created At
          </th>
          <td mat-cell *matCellDef="let message">
            {{ (message.date_created * 1000) | timezoneConvertMedium }}
          </td>
        </ng-container>

        <!-- UTC Date the message was created. -->
        <ng-container matColumnDef="date_created_UTC">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the message was created.">
            Created At (UTC)
          </th>
          <td mat-cell *matCellDef="let message">
            {{ (message.date_created * 1000) | timezoneConvertUTCMedium }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
          <td mat-cell *matCellDef="let message">
            <button type="button" mat-button *ngIf="canEditMessage(message)" (click)="onEditMessage(message.id)">
              Edit
            </button>
            <button type="button" mat-button *ngIf="message.status == 'sent'" (click)="onViewMessage(message.id)">
              View
            </button>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
      </table>

      <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
  </ng-container>

</div>
